var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import Button from "../Buttons/Button";
import { LeftOutlinedIcon } from "../Icons/Icons";
import SlideMediaItem from "../SlideMediaItem/SlideMediaItem";
import { useSelector } from "react-redux";
import { selectAppContent, selectCurrentEpisode, selectMobileDrawerOpen, setCurrentAgendaSelected, setCurrentAgendaSlideSelected } from "@adm-media/adam-store-plugin";
import { useAppDispatch } from "../../../store";
import { SanitizeHtml } from "../SanitizeHtml/SanitizeHtml";
import Typography from "../Typography/Typography";
import Divider from "../Divider/Divider";
import "./SlideSection.scss";
var Title = Typography.Title;
var SlideSection = function (_a) {
    var onCloseDrawer = _a.onCloseDrawer, props = __rest(_a, ["onCloseDrawer"]);
    var dispatch = useAppDispatch();
    var _b = useBreakpoint(), isMobile = _b.isMobile, isMiniTablet = _b.isMiniTablet, isTablet = _b.isTablet;
    var isSmallScreen = isMobile || isMiniTablet || isTablet;
    var _c = useState("slides-agenda-list"), view = _c[0], setView = _c[1];
    var contents = useSelector(selectAppContent);
    var episode = useSelector(selectCurrentEpisode);
    var onlyAgendaWithSlides = episode.agenda.filter(function (element) { return element.slides_config !== null; });
    var _d = useState([]), mobileSlidesOfClickedAgenda = _d[0], setMobileSlidesOfClickedAgenda = _d[1];
    var isMobileDrawerOpen = useSelector(selectMobileDrawerOpen);
    var onClickAgenda = function (id) {
        if (isSmallScreen) {
            setView("slides-agenda-mobile-list");
        }
        var agendaFound = onlyAgendaWithSlides.find(function (agenda) { return agenda.id === id; });
        setMobileSlidesOfClickedAgenda((agendaFound === null || agendaFound === void 0 ? void 0 : agendaFound.slides_config) || []);
        if (!agendaFound)
            return;
        dispatch(setCurrentAgendaSelected(agendaFound));
    };
    var onSingleClickMedia = function (slide) {
        dispatch(setCurrentAgendaSlideSelected(slide));
        onCloseDrawer && onCloseDrawer();
        setView("slides-agenda-list");
    };
    var agendas = view === "slides-agenda-list" && (_jsx("div", __assign({ className: "drawer-page show-slides-agenda-list" }, { children: onlyAgendaWithSlides.map(function (singleAgenda, i) {
            var _a, _b;
            return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "single-agenda-item", onClick: function () { return onClickAgenda(singleAgenda.id); } }, { children: [_jsx(Title, __assign({ level: 4, className: "single-agenda-item__title" }, { children: _jsx(SanitizeHtml, { stringToSanitize: singleAgenda.title, tag: "span" }) })), _jsx("div", __assign({ className: "single-agenda-item__title-img" }, { children: ((_a = singleAgenda === null || singleAgenda === void 0 ? void 0 : singleAgenda.slides_config) === null || _a === void 0 ? void 0 : _a[0].url) && _jsx("img", { src: (_b = singleAgenda === null || singleAgenda === void 0 ? void 0 : singleAgenda.slides_config[0]) === null || _b === void 0 ? void 0 : _b.url }) }))] }), singleAgenda.id), i + 1 !== onlyAgendaWithSlides.length && _jsx(Divider, {})] }));
        }) })));
    var agendaDetail = isSmallScreen && view === "slides-agenda-mobile-list" && (_jsxs("div", __assign({ className: "drawer-page show-detail" }, { children: [_jsx("div", __assign({ className: "button-container" }, { children: _jsx(Button, __assign({ icon: _jsx(LeftOutlinedIcon, {}), onClick: function () { return setView("slides-agenda-list"); } }, { children: contents.go_back_button_slide_text || "Go back" })) })), _jsx("div", __assign({ className: "media-container" }, { children: mobileSlidesOfClickedAgenda === null || mobileSlidesOfClickedAgenda === void 0 ? void 0 : mobileSlidesOfClickedAgenda.map(function (slide, i) { return (_jsx(React.Fragment, { children: _jsx(SlideMediaItem, { slide: slide, onSingleClickMedia: function () { return onSingleClickMedia(slide); }, isSmallScreen: isSmallScreen }) }, i)); }) }))] })));
    useEffect(function () {
        return function () {
            if (!isMobileDrawerOpen) {
                dispatch(setCurrentAgendaSelected(null));
                setView("slides-agenda-list");
            }
        };
    }, [isMobileDrawerOpen]);
    return (_jsx("div", __assign({ className: "slide-section-wrapper", "data-test": "slide-section-wrapper" }, props, { children: _jsx("div", __assign({ className: "slide-section ".concat(view === "slides-agenda-list" ? "show-slides-agenda-list" : "show-detail") }, { children: _jsxs(_Fragment, { children: [_jsx("div", { children: _jsx(SanitizeHtml, { stringToSanitize: 
                            // @ts-ignore
                            contents.slides_agenda_description ||
                                "In this section you can find the agendas with the available slides. Click a single agenda or scroll down to see more content.", tag: "span" }) }), agendas, agendaDetail] }) })) })));
};
export default SlideSection;
